import { getSupervisionSummary } from './supervision.action';

export { supervisionReducer } from './supervision.reducer';
export { watchSupervision } from './supervision.saga';

export const supervisionActions = {
    getSupervisionSummary,
};
